import {
  REGISTRATION_FLOWS,
  type RegistrationFlow,
  type RegistrationState,
} from '@repo/api-kit/queries/registration-states';
import type { RouteParams } from '../route-params';
import { AT_EXISTING_COMPANY_MAPPING } from './at-existing-company';
import { AT_GLOBAL_MAPPING } from './at-global';
import { BE_EXISTING_COMPANY_MAPPING } from './be-existing-company';
import { BE_GLOBAL_MAPPING } from './be-global';
import { DE_COMPANY_CREATION_MAPPING } from './de-company-creation';
import { DE_COMPANY_CREATION_SOLE_TRADER_MAPPING } from './de-company-creation-sole-trader';
import { DE_EMBED_EXISTING_COMPANY_MAPPING } from './de-embed-existing-company';
import { DE_EXISTING_COMPANY_MAPPING } from './de-existing-company';
import { DE_FULL_COMPANY_CREATION_COMPANIES_MAPPING } from './de-full-company-creation-companies';
import { DE_FULL_COMPANY_CREATION_FREELANCERS_MAPPING } from './de-full-company-creation-freelancers';
import { DE_FULL_COMPANY_CREATION_GBR_MAPPING } from './de-full-company-creation-gbr';
import { ES_COMPANY_CREATION } from './es-company-creation';
import { ES_EXISTING_COMPANY_MAPPING } from './es-existing-company';
import { ES_GLOBAL_MAPPING } from './es-global';
import { FR_COMPANY_CREATION } from './fr-company-creation';
import { FR_EMBED_EXISTING_COMPANY_MAPPING } from './fr-embed-existing-company';
import { FR_EMBED_QF_MAPPING } from './fr-embed-qf';
import { FR_EXISTING_COMPANY_MAPPING } from './fr-existing-company';
import { DE_GLOBAL_MAPPING } from './de-global';
import { FR_GLOBAL_MAPPING } from './fr-global';
import { IT_GLOBAL_MAPPING } from './it-global';
import { NL_GLOBAL_MAPPING } from './nl-global';
import { PT_GLOBAL_MAPPING } from './pt-global';
import { FR_FULL_COMPANY_CREATION_WITH_CAPITAL_DEPOSIT_MAPPING } from './fr-full-company-creation-with-capital-deposit';
import { FR_FULL_COMPANY_CREATION_WITHOUT_CAPITAL_DEPOSIT_MAPPING } from './fr-full-company-creation-without-capital-deposit';
import { FR_WORKS_COUNCIL_MAPPING } from './fr-works-council';
import { IT_COMPANY_CREATION } from './it-company-creation';
import { IT_EXISTING_COMPANY_MAPPING } from './it-existing-company';
import { NL_EXISTING_COMPANY_MAPPING } from './nl-existing-company';
import { PT_EXISTING_COMPANY_MAPPING } from './pt-existing-company';
import { NL_COMPANY_CREATION_MAPPING } from './nl-company-creation';
import { FR_EXISTING_COMPANY_INVOICING_UPSELL_MAPPING } from './fr-existing-company-invoicing-upsell';

export interface RegistrationStateMapping {
  url: string;
  routeParams: RouteParams[];
}

type RegistrationStatesMapping = {
  [_keyFlow in RegistrationFlow]: {
    [_keyState in RegistrationState]?: RegistrationStateMapping;
  };
};

export const REGISTRATION_STATES_MAPPING: RegistrationStatesMapping = {
  [REGISTRATION_FLOWS.AT_EXISTING_COMPANY]: AT_EXISTING_COMPANY_MAPPING,
  [REGISTRATION_FLOWS.BE_EXISTING_COMPANY]: BE_EXISTING_COMPANY_MAPPING,
  [REGISTRATION_FLOWS.DE_COMPANY_CREATION]: DE_COMPANY_CREATION_MAPPING,
  [REGISTRATION_FLOWS.DE_EXISTING_COMPANY]: DE_EXISTING_COMPANY_MAPPING,
  [REGISTRATION_FLOWS.DE_EMBED_EXISTING_COMPANY]: DE_EMBED_EXISTING_COMPANY_MAPPING,
  [REGISTRATION_FLOWS.DE_FULL_COMPANY_CREATION_COMPANIES]:
    DE_FULL_COMPANY_CREATION_COMPANIES_MAPPING,
  [REGISTRATION_FLOWS.DE_FULL_COMPANY_CREATION_FREELANCERS]:
    DE_FULL_COMPANY_CREATION_FREELANCERS_MAPPING,
  [REGISTRATION_FLOWS.DE_FULL_COMPANY_CREATION_GBR]: DE_FULL_COMPANY_CREATION_GBR_MAPPING,
  [REGISTRATION_FLOWS.DE_COMPANY_CREATION_SOLE_TRADER]: DE_COMPANY_CREATION_SOLE_TRADER_MAPPING,
  [REGISTRATION_FLOWS.ES_COMPANY_CREATION]: ES_COMPANY_CREATION,
  [REGISTRATION_FLOWS.ES_EXISTING_COMPANY]: ES_EXISTING_COMPANY_MAPPING,
  [REGISTRATION_FLOWS.FR_COMPANY_CREATION]: FR_COMPANY_CREATION,
  [REGISTRATION_FLOWS.FR_EXISTING_COMPANY]: FR_EXISTING_COMPANY_MAPPING,
  [REGISTRATION_FLOWS.FR_EMBED_EXISTING_COMPANY]: FR_EMBED_EXISTING_COMPANY_MAPPING,
  [REGISTRATION_FLOWS.FR_EMBED_QF]: FR_EMBED_QF_MAPPING,
  [REGISTRATION_FLOWS.DE_GLOBAL]: DE_GLOBAL_MAPPING,
  [REGISTRATION_FLOWS.FR_GLOBAL]: FR_GLOBAL_MAPPING,
  [REGISTRATION_FLOWS.ES_GLOBAL]: ES_GLOBAL_MAPPING,
  [REGISTRATION_FLOWS.IT_GLOBAL]: IT_GLOBAL_MAPPING,
  [REGISTRATION_FLOWS.NL_GLOBAL]: NL_GLOBAL_MAPPING,
  [REGISTRATION_FLOWS.AT_GLOBAL]: AT_GLOBAL_MAPPING,
  [REGISTRATION_FLOWS.BE_GLOBAL]: BE_GLOBAL_MAPPING,
  [REGISTRATION_FLOWS.PT_GLOBAL]: PT_GLOBAL_MAPPING,
  [REGISTRATION_FLOWS.FR_FULL_COMPANY_CREATION_WITH_CAPITAL_DEPOSIT]:
    FR_FULL_COMPANY_CREATION_WITH_CAPITAL_DEPOSIT_MAPPING,
  [REGISTRATION_FLOWS.FR_FULL_COMPANY_CREATION_WITHOUT_CAPITAL_DEPOSIT]:
    FR_FULL_COMPANY_CREATION_WITHOUT_CAPITAL_DEPOSIT_MAPPING,
  [REGISTRATION_FLOWS.FR_WORKS_COUNCIL]: FR_WORKS_COUNCIL_MAPPING,
  [REGISTRATION_FLOWS.IT_COMPANY_CREATION]: IT_COMPANY_CREATION,
  [REGISTRATION_FLOWS.IT_EXISTING_COMPANY]: IT_EXISTING_COMPANY_MAPPING,
  [REGISTRATION_FLOWS.NL_EXISTING_COMPANY]: NL_EXISTING_COMPANY_MAPPING,
  [REGISTRATION_FLOWS.NL_COMPANY_CREATION]: NL_COMPANY_CREATION_MAPPING,
  [REGISTRATION_FLOWS.PT_EXISTING_COMPANY]: PT_EXISTING_COMPANY_MAPPING,
  [REGISTRATION_FLOWS.FR_EXISTING_COMPANY_INVOICING_UPSELL]:
    FR_EXISTING_COMPANY_INVOICING_UPSELL_MAPPING,
};
